<div *ngIf="showWells"
	class="bk-dialog bk-dialog__event">
	<ranch-create-wells-step
		[form]="wellsForm"
		[subscriptions$]="_subscriptions$"
		(onCancel)="cancelWells()"
		(onBack)="cancelWells()"
		(nextStep)="continueFromWells()">
	</ranch-create-wells-step>
</div>

<div *ngIf="!showWells"
	class="bk-dialog bk-dialog__event">

    <button class="bk-modal__close_btn"
		(click)="cancelIncludingNContribution()"
		type="button">
		<mat-icon>close</mat-icon>
	</button>
    
    <h4 mat-dialog-title>
        {{'N Contribution from Water' | translate}}
    </h4>

    <div mat-dialog-content>
		<n-contribution
			[form]="form"
			[nContributionForm]="nContributionForm"
			[NContribution]="NContribution"
			[units]="units"
			[irrigationMethods]="irrigationMethods">
		</n-contribution>
	</div>

	<!-- footer -->

    <div mat-dialog-actions align="end">
		<button mat-button
			class="bk-button bk-button--medium bk-button--text-only"
			type="button"
			(click)="cancelIncludingNContribution()">
			{{'Cancel' | translate }}
		</button>

		<button mat-button
			class="bk-button bk-button--medium"
			[disabled]=""
			type="button"
			(click)="updateRecommendationWithNContribution()">
			{{'Update Recommendation With N Contribution' | translate }}
		</button>
    </div>
</div>
